import { stringify } from "query-string";
import { AppSettings } from "../config/appSettings";
import axiosWithAuth from "./axiosWithAuth";

// const apiUrl = `${AppSettings.server.baseUrl}`;
const apiUrl = `${AppSettings.server.baseUrl}/api/v1`;

const httpAxiosClient = axiosWithAuth;

const normalizeHeaders = (headers = new Headers()) => {
  if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries());
  }

  return headers;
};

const parseBody = (body, headers) => {
  if (!body) {
    return undefined;
  }

  const contentType = headers["Content-Type"] || headers["content-type"];

  if (typeof body === "string") {
    if (contentType && !contentType.includes("application/json")) {
      return body;
    }

    try {
      return JSON.parse(body);
    } catch {
      return body;
    }
  }

  return body;
};

const toResponseHeaders = (headers = {}) => {
  const responseHeaders = new Headers();

  Object.entries(headers).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      responseHeaders.set(key, value.join(", "));
      return;
    }

    if (value !== undefined) {
      responseHeaders.set(key, String(value));
    }
  });

  return responseHeaders;
};

const httpClient = async (url, options = {}) => {
  const headers = normalizeHeaders(options.headers);
  const response = await httpAxiosClient({
    url,
    method: options.method || "GET",
    headers,
    data: parseBody(options.body, headers),
  });

  return {
    status: response.status,
    headers: toResponseHeaders(response.headers),
    body:
      typeof response.data === "string"
        ? response.data
        : JSON.stringify(response.data),
    json: response.data,
  };
};

const isAdmin = localStorage.getItem("role") === "admin";
const logCall = (methodName, resource, params, url = "") => {
  console.log(
    `[React Admin] ${methodName.toUpperCase()} | ${resource} | ${url} |`,
    params,
  );
};
const dataProvider = {
  getList: async (resource, params) => {
    // console.log("QQQQ:", resource, params);

    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const updatedOrder = order === "ASC" ? field : `-${field}`;
    let filter = "";
    // filter[institute_id][like]=%COM%
    if (Object.keys(params.filter).length > 0) {
      const searchKey = Object.keys(params.filter)[0];
      const searchVal = params.filter[searchKey];
      filter = `filter[${searchKey}][like]=%${searchVal}%`;
    }

    const url = `${apiUrl}/${resource}?${filter}&sort=${updatedOrder}&page=${page}&limit=${perPage}`;
    if (isAdmin) {
      logCall("getList::", resource, params, url);
    }
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);

    const { json } = await httpClient(url, options);
    return {
      data: json.data,
      total: json.count,
    };
  },

  getOne: async (resource, params) => {
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    const url = `${apiUrl}/${resource}/${params.id}`;
    if (isAdmin) {
      logCall("getOne::", resource, params, url);
    }
    const { json } = await httpClient(
      `${apiUrl}/${resource}/${params.id}`,
      options,
    );
    return {
      data: json.data,
    };
  },

  get: async (resource, params) => {
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    let param = "";
    if (params && params.id) {
      param = `/${params.id}`;
    }
    const url = `${apiUrl}/${resource}${param}`;
    if (isAdmin) {
      logCall("get::", resource, params, url);
    }
    const { json } = await httpClient(`${apiUrl}/${resource}${param}`, options);
    return {
      data: json.data,
    };
  },

  getMany: async (resource, params) => {
    let filter = `filter[id][in]=[${[params.ids]}]`;
    const url = `${apiUrl}/${resource}?${filter}`;

    console.log("URL:", url);

    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    if (isAdmin) {
      logCall("getMany::", resource, params, url);
    }
    const { json } = await httpClient(url, options);
    return {
      data: json.data,
      total: json.count,
    };
  },

  getManyReference: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    if (isAdmin) {
      logCall("getManyReference::", resource, params, url);
    }
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);

    const { headers, json } = await httpClient(url, options);
    return {
      data: json,
      total: parseInt(headers.get("content-range").split("/").pop(), 10),
    };
  },

  update: async (resource, params) => {
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    options.method = "PUT";
    options.body = JSON.stringify(params.data);
    const url = `${apiUrl}/${resource}/${params.id}`;
    if (isAdmin) {
      logCall("get::", resource, params, url);
    }
    const { json } = await httpClient(
      `${apiUrl}/${resource}/${params.id}`,
      options,
    );
    return { data: json.data };
  },

  updateMany: async (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    if (isAdmin) {
      logCall("updateMany::", resource, params, url);
    }
    const { json } = await httpClient(
      `${apiUrl}/${resource}?${stringify(query)}`,
      {
        method: "PUT",
        body: JSON.stringify(params.data),
      },
    );
    return { data: json };
  },

  create: async (resource, params) => {
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    options.method = "POST";
    options.body = JSON.stringify(params.data);
    const url = `${apiUrl}/${resource}`;
    if (isAdmin) {
      logCall("create::", resource, params, url);
    }
    const { json } = await httpClient(`${apiUrl}/${resource}`, options);
    return {
      data: { ...params.data, id: json.id },
    };
  },

  post: async (resource, params) => {
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    options.method = "POST";
    options.body = JSON.stringify(params.data);
    const url = `${apiUrl}/${resource}`;
    if (isAdmin) {
      logCall("post::", resource, params, url);
    }
    await httpClient(`${apiUrl}/${resource}`, options);
    return {
      data: { ...params.data },
    };
  },

  upload: (resource, file, onUploadProgress, params) => {
    logCall("upload::", resource, params);
    let options = {};
    const token = localStorage.getItem("token");

    if (params && params.data) {
      options.body = JSON.stringify(params.data);
    }

    let formData = new FormData();

    formData.append("file", file);

    return httpAxiosClient.post(resource, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      onUploadProgress,
    });
  },

  delete: async (resource, params) => {
    logCall("delete::", resource, params);
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    options.method = "DELETE";
    const { json } = await httpClient(
      `${apiUrl}/${resource}/${params.id}`,
      options,
    );
    return { data: json.data };
  },

  deleteMany: async (resource, params) => {
    logCall("deleteMany::", resource, params);
    let options = {};
    const token = localStorage.getItem("token");
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Authorization", `Bearer ${token}`);
    options.body = JSON.stringify({ ids: params.ids });
    options.method = "DELETE";

    const { json } = await httpClient(
      `${apiUrl}/${resource}?ids=${params.ids}`,
      options,
    );
    return { data: json.data };
  },
};

export default dataProvider;
